import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdministrationComponent } from './administration.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AdministrationComponent
  ],
})
export class AdministrationModule { }


// WEBPACK FOOTER //
// ./src/app/administration/administration.module.ts